import { useLingui } from '@lingui/react'
import { type FC } from 'react'

import TransWithHtml from 'views/components/utils/TransWithHtml'

const SumBoxAGB: FC = () => {
  const { i18n } = useLingui()
  return (
    <div className="u-border--top">
      <p className="u-margin-large--bottom u-margin-large--top">
        <small>
          <TransWithHtml text={i18n._('general.cartSumBox.agb')} />
        </small>
      </p>
    </div>
  )
}

export default SumBoxAGB
